import { SVGProps, Ref, forwardRef } from 'react';

export const CrossOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.727 12 4 5.273 5.273 4 12 10.727 18.727 4 20 5.273 13.273 12 20 18.727 18.727 20 12 13.273 5.273 20 4 18.727z"
            fill="currentColor"
        />
    </svg>
));
CrossOutlinedSize24Glyph.displayName = 'CrossOutlinedSize24Glyph';
